import axios from "axios";
import Config from "src/config";

/**
 * Listar grupos de automações de um cliente
 * @param {string} cliente_id - ID do cliente
 * @returns {Promise} Promise com a resposta da API
 */
const v2_actionListarGruposAutomacoes = (cliente_id) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${cliente_id}/automacoes/grupos`
    });
};

/**
 * Criar novo grupo de automações
 * @param {string} cliente_id - ID do cliente
 * @param {Object} data - Dados do grupo
 * @param {string} data.name - Nome do grupo
 * @param {boolean} [data.status=true] - Status do grupo (padrão: true)
 * @returns {Promise} Promise com a resposta da API
 */
const v2_actionCriarGrupoAutomacoes = (cliente_id, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${cliente_id}/automacoes/grupos/criar`,
        data
    });
};

/**
 * Editar grupo de automações existente
 * @param {string} id - ID do grupo
 * @param {Object} data - Dados para atualização
 * @param {string} data.name - Novo nome do grupo
 * @param {boolean} [data.status] - Novo status do grupo
 * @returns {Promise} Promise com a resposta da API
 */
const v2_actionEditarGrupoAutomacoes = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/automacoes/grupos/${id}/editar`,
        data
    });
};

/**
 * Deletar grupo de automações (soft delete)
 * @param {string} id - ID do grupo
 * @returns {Promise} Promise com a resposta da API
 */
const v2_actionDeletarGrupoAutomacoes = (id) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/automacoes/grupos/${id}/deletar`
    });
};

export {
    v2_actionListarGruposAutomacoes,
    v2_actionCriarGrupoAutomacoes,
    v2_actionEditarGrupoAutomacoes,
    v2_actionDeletarGrupoAutomacoes
};
